import { trigger, style, animate, transition } from '@angular/animations';

export const MODAL = trigger('modalDisplay', [
  transition(':enter', [
    style({ transform: 'translate(-50%, -150%)', opacity: 0 }),
    animate(
      '0.3s ease-in-out',
      style({ transform: 'translate(-50%, -50%)', opacity: 1 })
    ),
  ]),
  transition(':leave', [
    style({ transform: 'translate(-50%, -50%)', opacity: 1 }),
    animate(
      '0.3s ease-in-out',
      style({ transform: 'translate(-50%, -150%)', opacity: 0 })
    ),
  ]),
]);

export const MOBILE_MODAL = trigger('modalMobileDisplay', [
  transition(':enter', [
    style({ transform: 'translateY(-150%)', opacity: 0 }),
    animate(
      '0.3s ease-in-out',
      style({ transform: 'translate(0%, 0%)', opacity: 1 })
    ),
  ]),
  transition(':leave', [
    style({ transform: 'translate(0%, 0%)', opacity: 1 }),
    animate(
      '0.3s ease-in-out',
      style({ transform: 'translateY( -150%)', opacity: 0 })
    ),
  ]),
]);
